import React from "react";
import { Button, Col, Row } from "react-bootstrap";

function ClickableSquare({ tabs, currentTab, setCurrentTab }) {
  return (
    <Row>
      <Col xs={12}>
        <ul className="list-unstyled gap-4 d-flex flex-wrap">
          
          {tabs?.map((tab) => (
            <div
              className="bg-light3 m-0 rounded-3 overflow-hidden"
              key={tab.id}
            >
              <li>
                <Button
                  variant="text"
                  onClick={() => setCurrentTab(tab.id)}
                  className={`border-0 btn-outline-light fw-bold px-4 text-black py-2 bottom bottom-0 ${
                    currentTab === tab.id && "bg-primary text-white"
                  }`}
                >
                  <p>{tab.name}</p>
                </Button>
              </li>
            </div>
          ))}
        </ul>
      </Col>
    </Row>
  );
}

export default React.memo(ClickableSquare)